import types from '../actionTypes';

export const updateInfoCategoryRequest = (form, id, payload) => ({
    type: types.UPDATE_INFO_CATEGORY_REQUEST,
    meta: {
        form,
        id,
    },
    payload,
});

export const updateInfoCategoryOrder = meta => ({
    type: types.UPDATE_INFO_CATEGORY_ORDER,
    meta,
});

export const updateInfoRequest = (form, id, categoryId, payload) => ({
    type: types.UPDATE_INFO_REQUEST,
    meta: {
        form,
        id,
        categoryId,
    },
    payload,
});

export const updateInfoOrder = (categoryId, meta) => ({
    type: types.UPDATE_INFO_ORDER,
    meta: {
        ...meta,
        categoryId,
    },
});
